/* tslint:disable */
/* eslint-disable */
/**
 * Token.WebApi v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {EventOccurrenceDto} from './EventOccurrenceDto';
import {
  EventOccurrenceDtoFromJSON,
  EventOccurrenceDtoFromJSONTyped,
  EventOccurrenceDtoToJSON,
  EventOccurrenceDtoToJSONTyped,
} from './EventOccurrenceDto';
import type {AddressDto} from './AddressDto';
import {
  AddressDtoFromJSON,
  AddressDtoFromJSONTyped,
  AddressDtoToJSON,
  AddressDtoToJSONTyped,
} from './AddressDto';

/**
 *
 * @export
 * @interface EventSummaryDto
 */
export interface EventSummaryDto {
  /**
   *
   * @type {string}
   * @memberof EventSummaryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventSummaryDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EventSummaryDto
   */
  description: string;
  /**
   *
   * @type {number}
   * @memberof EventSummaryDto
   */
  locationCode: number;
  /**
   *
   * @type {AddressDto}
   * @memberof EventSummaryDto
   */
  address: AddressDto;
  /**
   *
   * @type {string}
   * @memberof EventSummaryDto
   */
  groupId?: string | null;
  /**
   *
   * @type {Array<EventOccurrenceDto>}
   * @memberof EventSummaryDto
   */
  occurrences: Array<EventOccurrenceDto>;
  /**
   *
   * @type {Array<string>}
   * @memberof EventSummaryDto
   */
  photoUrls: Array<string>;
}

/**
 * Check if a given object implements the EventSummaryDto interface.
 */
export function instanceOfEventSummaryDto(
  value: object,
): value is EventSummaryDto {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined)
    return false;
  if (!('locationCode' in value) || value['locationCode'] === undefined)
    return false;
  if (!('address' in value) || value['address'] === undefined) return false;
  if (!('occurrences' in value) || value['occurrences'] === undefined)
    return false;
  if (!('photoUrls' in value) || value['photoUrls'] === undefined) return false;
  return true;
}

export function EventSummaryDtoFromJSON(json: any): EventSummaryDto {
  return EventSummaryDtoFromJSONTyped(json, false);
}

export function EventSummaryDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EventSummaryDto {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    description: json['description'],
    locationCode: json['locationCode'],
    address: AddressDtoFromJSON(json['address']),
    groupId: json['groupId'] == null ? undefined : json['groupId'],
    occurrences: (json['occurrences'] as Array<any>).map(
      EventOccurrenceDtoFromJSON,
    ),
    photoUrls: json['photoUrls'],
  };
}

export function EventSummaryDtoToJSON(json: any): EventSummaryDto {
  return EventSummaryDtoToJSONTyped(json, false);
}

export function EventSummaryDtoToJSONTyped(
  value?: EventSummaryDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    name: value['name'],
    description: value['description'],
    locationCode: value['locationCode'],
    address: AddressDtoToJSON(value['address']),
    groupId: value['groupId'],
    occurrences: (value['occurrences'] as Array<any>).map(
      EventOccurrenceDtoToJSON,
    ),
    photoUrls: value['photoUrls'],
  };
}
